import React from 'react'
import agent from '../agent'
import { Link } from 'react-router-dom';
import { connect } from 'react-redux'
import moment from 'moment';
import {
    CATEGORY_LIST_PAGE_LOADED,
    CATEGORY_LIST_PAGE_UNLOADED,
} from '../constants/actionTypes'
import CategoryList from './widgets/CategoryList';

const mapStateToProps = state => ({
    ...state.category,
    appName: state.common.appName,
    token: state.common.token,
});

const mapDispatchToProps = dispatch => ({
    onLoad: (payload) => {
        dispatch({ type: CATEGORY_LIST_PAGE_LOADED, payload })
    },
    onUnload: () =>
        dispatch({ type: CATEGORY_LIST_PAGE_UNLOADED }),
});

class Categories extends React.Component {
    constructor() {
        super();
    }
    componentWillMount() {
        const payload = agent.Categories.getCategories(this.props.match.params.key)
        this.props.onLoad(payload);
    }
    componentWillUnmount() {
        this.props.onUnload();
    }

    render() {

        return (
            <div className='pane'>
                <Link className="crumb" to={`/users/${this.props.match.params.key}`}>&laquo; back to user detail</Link>
                <h1>User Category list</h1>
                <CategoryList categories={this.props.categories} loading={this.props.loading} />
            </div >
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Categories);



// WEBPACK FOOTER //
// ./src/components/Categories.js